module.exports = __webpack_public_path__ + "img/four2Green.b18ade56.jpg";